import { createSelector } from 'reselect';
import { getFormValues } from 'redux-form';
import { filter } from 'ramda';

import { filterByString } from '@topconagriculture/frontend-utils';

import { RootState } from '../../reducers';
import { Forms } from '../../form/form.selector';

export const getLocations = (state: RootState) => state.entities.locations;

export const getLocationsFilteredBySearch = createSelector(
  [getLocations, getFormValues(Forms.locationsSearch)],
  (locations, filterForm: any) => {
    return filterForm?.search
      ? filter((location) => filterByString(location.description, filterForm.search), locations)
      : locations;
  },
);
